import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AnimationComponent } from './layout/wizard/view-game/animation/animation.component';

const routes: Routes = [

  { path: 'animation', component: AnimationComponent },
  { path: '**', component: LayoutComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
